export class HashTable<TValue> {
    private data: { [key: string]: TValue };

    add(key: string, value: TValue): void {
        this.data[key] = value;
    }

    contains(key: string): boolean {
        return key in this.data;
    }

    remove(key: string): boolean {
        if (this.contains(key)) {
            delete this.data[key];
            return true;
        }
        return false;
    }

    get(key: string): TValue {
        if (this.contains(key)) {
            return this.data[key];
        }
        return null;
    }
}
